__turbopack_context__.v({
  "animated": "Footer-module__SkqdAq__animated",
  "bookConsultation": "Footer-module__SkqdAq__bookConsultation",
  "brand": "Footer-module__SkqdAq__brand",
  "brandLogo": "Footer-module__SkqdAq__brandLogo",
  "doAnimation": "Footer-module__SkqdAq__doAnimation",
  "eyebrow": "Footer-module__SkqdAq__eyebrow",
  "finalCta": "Footer-module__SkqdAq__finalCta",
  "finalInner": "Footer-module__SkqdAq__finalInner",
  "finalRow": "Footer-module__SkqdAq__finalRow",
  "footerBottom": "Footer-module__SkqdAq__footerBottom",
  "footerBrand": "Footer-module__SkqdAq__footerBrand",
  "footerContainer": "Footer-module__SkqdAq__footerContainer",
  "footerGrid": "Footer-module__SkqdAq__footerGrid",
  "footerMeta": "Footer-module__SkqdAq__footerMeta",
  "kicker": "Footer-module__SkqdAq__kicker",
  "orbit": "Footer-module__SkqdAq__orbit",
  "reveal-up": "Footer-module__SkqdAq__reveal-up",
  "title": "Footer-module__SkqdAq__title",
  "titleGerman": "Footer-module__SkqdAq__titleGerman",
});
